import AssetParametersApi from './assetParametersApi';
import AssetTypesApi from './assetTypesApi';
import ClosingCodesApi from './closingCodesApi';
import ElementUIsApi from './elementUIsApi';
import FieldFillingControlsApi from './fieldFillingControlsApi';
import IApiCalls from './interfaces/apiCalls';
import IAssetParametersApi from './interfaces/assetParametersApi';
import IAssetTypesApi from './interfaces/assetTypesApi';
import IClosingCodesApi from './interfaces/closingCodesApi';
import IElementUIsApi from './interfaces/elementUIsApi';
import IFieldFillingControlsApi from './interfaces/fieldFillingControlsApi';
import IOperationTypesApi from './interfaces/operationTypesApi';
import IRoleUIsApi from './interfaces/roleUIsApi';
import IScheduleApi from './interfaces/scheduleApi';
import IStatusTransitionsApi from './interfaces/statusTransitionsApi';
import ITaskProcessingProcessApi from './interfaces/taskProcessingProcessApi';
import ITaskStatusesApi from './interfaces/taskStatusesApi';
import ITaskTypesApi from './interfaces/taskTypesApi';
import IVerificationFunctionsApi from './interfaces/verificationFunctionsApi';
import OperationTypesApi from './operationTypesApi';
import RoleUIsApi from './roleUIsApi';
import ScheduleApi from './ScheduleApi';
import StatusTransitionsApi from './statusTransitionsApi';
import TaskProcessingProcessApi from './taskProcessingProcessApi';
import TaskStatusesApi from './taskStatusesApi';
import TaskTypesApi from './taskTypesApi';
import VerificationFunctionsApi from './verificationFunctionsApi';

class ApiCalls implements IApiCalls {
  private readonly _controller: AbortController;

  constructor() {
    this._controller = new AbortController();
    this.ClosingCodes = new ClosingCodesApi(this._controller);
    this.TaskTypes = new TaskTypesApi(this._controller);
    this.TaskProcessingProcesses = new TaskProcessingProcessApi(
      this._controller
    );
    this.OperationTypes = new OperationTypesApi(this._controller);
    this.Schedule = new ScheduleApi(this._controller);
    this.TaskStatuses = new TaskStatusesApi(this._controller);
    this.FieldFillingControls = new FieldFillingControlsApi(this._controller);
    this.VerificationFunctions = new VerificationFunctionsApi(this._controller);
    this.AssetTypes = new AssetTypesApi(this._controller);
    this.AssetParameters = new AssetParametersApi(this._controller);
    this.StatusTransitions = new StatusTransitionsApi(this._controller);
    this.RoleUIs = new RoleUIsApi(this._controller);
    this.ElementUIs = new ElementUIsApi(this._controller);
    this.cancelAllCalls = this.cancelAllCalls.bind(this);
  }

  beginApiCalls() {
    return new ApiCalls();
  }

  public ClosingCodes: IClosingCodesApi;
  public TaskTypes: ITaskTypesApi;
  public TaskProcessingProcesses: ITaskProcessingProcessApi;
  public OperationTypes: IOperationTypesApi;
  public Schedule: IScheduleApi;
  public TaskStatuses: ITaskStatusesApi;
  public FieldFillingControls: IFieldFillingControlsApi;
  public VerificationFunctions: IVerificationFunctionsApi;
  public AssetTypes: IAssetTypesApi;
  public AssetParameters: IAssetParametersApi;
  public StatusTransitions: IStatusTransitionsApi;
  public RoleUIs: IRoleUIsApi;
  public ElementUIs: IElementUIsApi;

  cancelAllCalls() {
    this._controller.abort();
  }
}

export default ApiCalls;
